import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCountriesRequest } from '../../actions/fetchCountriesActions';
import { currenciesSelector, defaultCurrencySelector } from '../../reducers/selectors';

const useDefaultCurrency = () => {
  const dispatch = useDispatch();
  const currencies = useSelector(currenciesSelector);
  const defaultCurrency = useSelector(defaultCurrencySelector);

  useLayoutEffect(() => {
    if (currencies.length === 0) {
      dispatch(fetchCountriesRequest());
    }
  }, [currencies, dispatch]);

  return [defaultCurrency, currencies];
};

export default useDefaultCurrency;
